// 默认easyMock生成的文件在src/api/template下
import API from '@/api/common.js'
import * as types from './mutation-types'
import router from '@/router'
import storage from 'good-storage'
import i18n from '@/i18n'
import utils from '@/utils/util'
export default {
  setUserInfo (context) {
    return new Promise(async resolve => {
      // userInfo模拟数据，真是开发环境中可以去掉，使用接口获取
      let data = {
        languageId: 'zh_CN',
        skin: 'redblack',
        breadcrumb: {
          '001': [
            // eslint-disable-next-line
            '欢迎'
          ]
        },
        code: [`${process.env.VUE_APP_CONTEXT}_001`]
      }
      // 如果不用mock数据可以打开这行
      let basicInfo = {}
      await API.basicInfo({ language: storage.get('portal_language') }).then(res => {
        basicInfo = res.data
      })
      //data['languageId'] = basicInfo.language || 'zh_CN'
      data['languageId'] = utils.browserLangMap() // basicInfo.language || 'zh_CN'
      // data['skin'] = 'redblack'
      data['skin'] = basicInfo.skin || 'redblack'
      // data['languageId'] = 'en_US'
      context.commit(types.SET_USER_INFO, data)
      context.commit(types.SET_USER_NAME, basicInfo.userName)
      context.commit(types.SET_BASICINFO, basicInfo || {})
      resolve({
        userInfo: data
      })
    })
  },
  addTabMenu ({ commit, state }, { menu, closeable = true }) {
    let _menu = JSON.parse(JSON.stringify(menu))
    _menu._info = makeMenuInfo(_menu)
    _menu._closeable = closeable
    let _index = -1
    state.tabMenus.forEach((item, index) => {
      if (item.menuId === menu.menuId) {
        _index = index
      }
    })
    if (_index === -1) {
      // 添加一个菜单到导航栏Tab菜单中
      commit(types.ADD_TAB_MENUS, _menu)
    }
    // 将这个菜单设置为选中状态
    let params = {
      menuId: _menu.menuId,
      componentMenuId: _menu.componentMenuId,
      permissionCode: _menu.permissionCode
    }
    commit(types.SET_ACTIVE_TAB_MENU, params)
    // 将处理后的数据同步到SessionStorage中
    storage.session.set(`portal-tab-menus-${state.userName}`, state.tabMenus)
    storage.session.set(`portal-active-tab-menu-${state.userName}`, state.activeTabMenu)
  },
  // 用于业务组件打开其他组件或页面时，更新tabMenu
  addTabMenuTop ({ commit, state, dispatch }, { menu, targetMenu }) {
    let _menu = JSON.parse(JSON.stringify(menu))
    _menu._info = makeMenuInfo(_menu)
    _menu._closeable = true
    let _index = -1
    state.tabMenus.forEach((item, index) => {
      if (item.menuId === menu.menuId) {
        _index = index
      }
    })
    if (_index === -1) {
      // 添加一个菜单到导航栏Tab菜单中
      commit(types.ADD_TAB_MENUS, _menu)
    }
    // 将这个菜单设置为选中状态
    let params = {
      menuId: _menu.menuId,
      componentMenuId: _menu.componentMenuId,
      permissionCode: _menu.permissionCode
    }
    commit(types.SET_ACTIVE_TAB_MENU, params)
    dispatch({
      type: 'updateTabMenuItem',
      isCollapse: false,
      showUrl: targetMenu.fullUrl,
      activeIndex: targetMenu._path,
      openedMenus: []
    })
    // 将处理后的数据同步到SessionStorage中
    storage.session.set(`portal-tab-menus-${state.userName}`, state.tabMenus)
    storage.session.set(`portal-active-tab-menu-${state.userName}`, state.activeTabMenu)
  },
  removeTabMenu ({ commit, state }, { menuId }) {
    let _index = state.tabMenus.findIndex(item => item.menuId === menuId)
    _index = _index - 1 < 0 ? 0 : _index - 1
    const _nextMenu = state.tabMenus[_index]
    // 将对应的菜单从Tab里面删除
    commit(types.REMOVE_TAB_MENUS, menuId)
    // 如果删除的是选中状态下的菜单，则选中前一个菜单
    router.push({
      path: _nextMenu._path,
      query: router.app.$route.query
    })
    if (state.activeTabMenu === menuId) {
      let params = {
        menuId: _nextMenu.menuId,
        componentMenuId: _nextMenu.componentMenuId,
        permissionCode: _nextMenu.permissionCode
      }
      commit(types.SET_ACTIVE_TAB_MENU, params)
    }
    // 将处理后的数据同步到SessionStorage中
    storage.session.set(`portal-tab-menus-${state.userName}`, state.tabMenus)
    storage.session.set(`portal-active-tab-menu-${state.userName}`, state.activeTabMenu)
  },
  updateTabMenuItem (
    { commit, state },
    { isCollapse, showUrl, activeIndex, openedMenus }
  ) {
    let _info = {
      isCollapse,
      showUrl,
      activeIndex,
      openedMenus
    }
    commit(types.UPDATE_TAB_MENU_ITEM, _info)

    // 将处理后的数据同步到SessionStorage中
    storage.session.set(`portal-tab-menus-${state.userName}`, state.tabMenus)
    storage.session.set(`portal-active-tab-menu-${state.userName}`, state.activeTabMenu)
  },
  setUserName ({ commit, state }, { userName }) {
    commit(types.SET_USER_NAME, userName)
  },
  setExtendData ({ commit }, data) {
    commit(types.SET_EXTEND_DATA, data)
  },
  setTags ({ commit, state }, { tags }) {
    commit(types.SET_TAGS_DISPLAYBOARD, tags)
  },
  setTlncTodoMenuId ({ commit, state }, { todo }) {
    commit(types.SET_TODO_MENU_ID, todo)
  },
  setTlncMessageMenuId ({ commit, state }, { msg }) {
    commit(types.SET_MESSAGE_MENU_ID, msg)
  },
  openMenuStatic ({ commit, state, dispatch }, { id, value, key, url }) {
    let _menu = {
      fullUrl: url,
      menuId: id,
      name: value,
      url: url,
      showUrl: url,
      _hasChild: false,
      _path: `/index/view/${id}`,
      children: []
    }
    if (state.navigateSchema === 'nav-type1') {
      dispatch({
        type: 'addTabMenu',
        menu: _menu
      }).then(() => {
        router.push({
          path: _menu._path,
          query: router.app.$route.query
        })
      })
    } else {
      window.open(url)
    }
  },
  openMenu ({ commit, state, dispatch }, { value, key, url }) {
    let temp = findMenu(state.appMenus, value, key)
    let _menu = JSON.parse(JSON.stringify(temp))
    let viewType = _menu.menuId === 'home' ? 'home' : 'view'
    commit(types.SET_VIEW_TYPE, viewType)
    if (state.navigateSchema === 'nav-type1') {
      if (!_menu) {
        let _id = new Date().getTime().toString()
        _menu = {
          showUrl: url,
          name: key === 'name' ? value : '未知菜单',
          menuId: _id,
          _path: `/index/view/${_id}`,
          _hasChild: false,
          children: []
        }
      }
      dispatch({
        type: 'addTabMenu',
        menu: _menu
      }).then(() => {
        // router.push({
        //   path: _menu._path,
        //   query: router.app.$route.query
        // })
      })
    } else {
      if (!_menu) {
        window.open(url)
      } else {
        let params = {
          menuId: _menu.menuId,
          componentMenuId: _menu.componentMenuId,
          permissionCode: _menu.componentMenuId
        }
        commit(types.SET_ACTIVE_TAB_MENU, params)
      }
    }
  },
  closeActiveLeft ({ commit, state, dispatch }) {
    let _activeIndex = state.tabMenus.findIndex(item => {
      return item.menuId === state.activeTabMenu
    })
    let _menus = []
    state.tabMenus.forEach((item, index) => {
      // if (!item._closeable) {
      //   _menus.push(item);
      // } else if (index >= _activeIndex) {
      //   _menus.push(item);
      // }
      if (item.menuId === 'home') {
        _menus.push(item)
      } else if (index >= _activeIndex) {
        _menus.push(item)
      }
    })
    commit(types.SET_TAB_MENUS, _menus)
    // 将处理后的数据同步到SessionStorage中
    storage.session.set(`portal-tab-menus-${state.userName}`, state.tabMenus)
    storage.session.set(`portal-active-tab-menu-${state.userName}`, state.activeTabMenu)
  },
  closeActiveRight ({ commit, state, dispatch }) {
    let _activeIndex = state.tabMenus.findIndex(item => {
      return item.menuId === state.activeTabMenu
    })
    let _menus = []
    state.tabMenus.forEach((item, index) => {
      if (item.menuId === 'home') {
        _menus.push(item)
      } else if (index <= _activeIndex) {
        _menus.push(item)
      }
    })
    commit(types.SET_TAB_MENUS, _menus)
    // 将处理后的数据同步到SessionStorage中
    storage.session.set(`portal-tab-menus-${state.userName}`, state.tabMenus)
    storage.session.set(`portal-active-tab-menu-${state.userName}`, state.activeTabMenu)
  },
  closeActiveOther ({ commit, state, dispatch }) {
    let _menus = []
    state.tabMenus.forEach((item, index) => {
      if (item.menuId === 'home') {
        _menus.push(item)
      } else if (item.menuId === state.activeTabMenu) {
        _menus.push(item)
      }
    })
    commit(types.SET_TAB_MENUS, _menus)
    // 将处理后的数据同步到SessionStorage中
    storage.session.set(`portal-tab-menus-${state.userName}`, state.tabMenus)
    storage.session.set(`portal-active-tab-menu-${state.userName}`, state.activeTabMenu)
  },
  closeAll ({ commit, state, dispatch }) {
    let _menus = []
    let _activeTabMenu = ''
    state.tabMenus.forEach((item, index) => {
      if (item.menuId === 'home') {
        _menus.push(item)
        _activeTabMenu = item
      }
    })
    router.push({
      path: _activeTabMenu._path,
      query: router.app.$route.query
    })
    commit(types.SET_TAB_MENUS, _menus)
    let params = {
      menuId: _activeTabMenu.menuId,
      componentMenuId: _activeTabMenu.componentMenuId,
      permissionCode: _activeTabMenu.permissionCode
    }
    commit(types.SET_ACTIVE_TAB_MENU, params)
    // 将处理后的数据同步到SessionStorage中
    storage.session.set(`portal-tab-menus-${state.userName}`, state.tabMenus)
    storage.session.set(`portal-active-tab-menu-${state.userName}`, state.activeTabMenu)
  },
  backfillData ({ commit, state }) {
    // 从localstorage中查看是否记忆标签
    let rmbHisTab = !!storage.get(`rmbHisTab-${state.userName}`)
    let historyArgusFlag = !!storage.get(`cross-menu-params-${state.userName}`)
    let _menus = (rmbHisTab || historyArgusFlag)
      ? storage.session.get(`portal-tab-menus-${state.userName}`) || []
      : [
        {
          _path: '/index/home',
          name: i18n.t('common.index_page'),
          menuId: 'home'
        }
      ]
    let _activeMenu = (rmbHisTab || historyArgusFlag)
      ? storage.session.get(`portal-active-tab-menu-${state.userName}`) || ''
      : 'home'
    if (rmbHisTab && !historyArgusFlag) {
      let viewType = storage.session.get(`viewType-${state.userName}`) || 'home'
      commit(types.SET_VIEW_TYPE, viewType)
    }
    let _active = _menus.filter(item => item.menuId === _activeMenu)
    // 将数据从SessionStorage中同步回来
    commit(types.SET_TAB_MENUS, _menus)
    if (_active && _active.length > 0) {
      let params = {
        menuId: _activeMenu,
        componentMenuId: _active[0].componentMenuId,
        permissionCode: _active[0].permissionCode
      }
      commit(types.SET_ACTIVE_TAB_MENU, params)
    } else {
      let params = {
        menuId: _activeMenu,
        componentMenuId: '',
        permissionCode: ''
      }
      commit(types.SET_ACTIVE_TAB_MENU, params)
    }
    if (historyArgusFlag) {
      storage.remove(`cross-menu-params-${state.userName}`)
    }
    return _active && _active.length ? _activeMenu : ''
  },
  // 业务组件通过componentMenuId或url打开其他菜单
  openApp ({ commit, state, dispatch }, { value, key, url, param }) {
    let temp = null
    let _menu = null
    let _targetMenu = null
    if (!url) {
      temp = findMenuAndSetDeep(state.appMenus, value, key, 0)
      _menu = JSON.parse(JSON.stringify(temp))
      _targetMenu = findMenu(state.appMenus, value, key)
    }
    if (state.navigateSchema === 'nav-type1') {
      if (!_menu) {
        let _id = new Date().getTime().toString()
        _menu = {
          showUrl: url,
          fullUrl: url,
          name: key === 'name' ? value : i18n.t('common.unkonw_menu'),
          menuId: _id,
          _path: `/index/view/${_id}`,
          _hasChild: false,
          children: []
        }
        _targetMenu = _menu
      } else {
        _menu = findTargetMenu(state.appMenus, _menu)
      }
      if (param) {
        if (_targetMenu.fullUrl.indexOf('?') !== -1) {
          _targetMenu.fullUrl += `&${param}`
        } else {
          _targetMenu.fullUrl += `?${param}`
        }
      }
      dispatch({
        type: 'addTabMenuTop',
        menu: _menu,
        targetMenu: _targetMenu
      })
    } else {
      if (!_menu) {
        window.open(url)
      } else {
        // router.push({
        //   path: _menu._path,
        //   query: router.app.$route.query
        // })
        let params = {
          menuId: _menu.menuId,
          componentMenuId: _menu.componentMenuId,
          permissionCode: _menu.componentMenuId
        }
        let viewType = _menu.menuId === 'home' ? 'home' : 'view'
        commit(types.SET_VIEW_TYPE, viewType)
        commit(types.SET_ACTIVE_TAB_MENU, params)
      }
    }
  }

}

function makeMenuInfo (menu) {
  let _info = {}
  _info.isCollapse = false
  _info.showUrl = menu.fullUrl || ''
  if (menu._hasChild && !menu.fullUrl) {
    let _child = menu.children[0]
    if (_child._hasChild) {
      _info.activeIndex = _child.children[0]._path
      _info.openedMenus = [_child._path]
      _info.showUrl = _child.children[0].fullUrl || ''
    } else {
      _info.activeIndex = _child._path
      _info.openedMenus = []
      _info.showUrl = _child.fullUrl || ''
    }
  } else {
    _info.activeIndex = ''
    _info.openedMenus = []
    _info.showUrl = menu.fullUrl || ''
  }
  return _info
}

function findMenu (arr, value, key) {
  for (let i = 0; i < arr.length; i++) {
    if (arr[i][key] === value) {
      return arr[i]
    }
    if (arr[i]._hasChild) {
      let _res = findMenu(arr[i].children, value, key)
      if (_res) return _res
    }
  }
  return null
}

function findMenuAndSetDeep (arr, value, key, deep) {
  deep++
  for (let i = 0; i < arr.length; i++) {
    arr[i]['deep'] = deep
    if (arr[i][key] === value) {
      return arr[i]
    }
    if (arr[i]._hasChild) {
      let _res = findMenuAndSetDeep(arr[i].children, value, key, deep)
      if (_res) return _res
    }
  }
  return null
}

function findTargetMenu (allMenus, _menu) {
  // 如果已经是二级的菜单了 直接返回该菜单
  if (_menu.deep === 2) return _menu
  let upMenu = findMenuAndSetDeep(allMenus, _menu.parentId, 'menuId', 0)
  if (upMenu.deep > 2) {
    return findTargetMenu(allMenus, upMenu)
  } else {
    return upMenu
  }
}
